import { Link } from "react-router-dom";

interface EmptyStateProps {
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function EmptyState({
  title,
  description,
  actionLabel,
  actionTo,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6 rounded-lg bg-background-100 border border-background-200">
      <span className="w-16 h-16 rounded-full bg-background-200 text-foreground-400 flex items-center justify-center mb-4">
        <i className="ri-film-line text-2xl"></i>
      </span>
      <h3 className="font-heading font-bold text-lg text-foreground-950">{title}</h3>
      {description && (
        <p className="mt-2 text-sm text-foreground-500 max-w-md">{description}</p>
      )}
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="mt-6 px-5 h-10 inline-flex items-center gap-1.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-arrow-left-line"></i>
          {actionLabel}
        </Link>
      )}
    </div>
  );
}